export function setParentSurveys(state, data) {
  state.parent_surveys = data
}

export function cleanErrors(state) {
  state.error = "";
}

export function error(state, error) {
  state.error = error;
}